<template>
  <v-app>
    <v-app-bar app color="gray" dark>
      <v-container class="d-flex align-center">
        <div class="d-flex align-center">
          <v-img :src="require('./assets/logo.png')" alt="Adosia" contain width="192" />
        </div>
        <v-spacer></v-spacer>
        <v-btn v-if="adaValue !== null">
          ADA-USD: ${{ adaValue.toLocaleString(undefined, lovelace_format) }}
          <v-icon v-if="adaValue != null && lastAdaValue != null && adaValue !== lastAdaValue"
                  :color="adaValue > lastAdaValue ? 'green' : 'red'">
            {{ adaValue > lastAdaValue ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
          </v-icon>
        </v-btn>
      </v-container>

    </v-app-bar>

    <v-main>
      <v-container>
        <v-progress-linear v-if="cardano.status === 'init'" height="12" color="orange"
                           indeterminate></v-progress-linear>
        <v-row justify="center">
          <v-col cols="12" lg="8" xl="6" class="justify-center text-center">
            <h1 class="justify-center text-center">
              Get an IRL 3D Print of your Adosia Space Rocket </h1>
            <v-alert color="" border="left" class="text-start">
              <p>
                Please be aware that orders will be fulfilled by our decentralized network of 3D printer operators
                around the world. Please allow 6-8 weeks for completion and delivery of your order. </p>
              <p>
                The cost is ${{ (79.95).toLocaleString() }} USD (paid in ADA at the time or your order) per printed
                rocket and includes global shipping. </p>
              <p class="mb-0">
                We cannot make changes once your order is submitted, please ensure that you are selecting the correct
                rocket and your shipping address is correct in the form. </p>
            </v-alert>
          </v-col>
        </v-row>
        <div v-if="order_id && order_status">
          <v-row justify="center">
            <v-col cols="12" lg="8" xl="6">
              <h2 class="mb-4">Order Details Found</h2>
              <div class="my-2" v-if="orderBusy">
                <v-progress-linear indeterminate color="primary" height="30">
                  <strong>Checking Order Status...</strong>
                </v-progress-linear>
              </div>
              <p class="mb-1">
                <strong>Order Status:</strong>
                <v-chip label color="orange" class="text-capitalize mx-4" id="order-status">
                  {{ order_status.status }}
                </v-chip>
              </p>
              <p class="mb-1">
                <strong>Order ID:</strong> <span id="order-id" class="mx-2">{{ order_status.order_id }}</span>
              </p>
              <p class="mb-1">
                <strong>Placed On:</strong> <span id="order-date" class="mx-2">
                {{ new Date(order_status.placed_at).toLocaleString() }}</span>
              </p>
              <p class="mb-1">
                <strong>Rocket to Print:</strong> <span id="rocket-id" class="mx-2">{{ order_status.rocket_id }}</span>
              </p>
              <p class="mb-1">
                <strong>Price:</strong> <span id="order-price" class="mx-2">
                {{ toAda(order_status.price).toLocaleString(undefined, lovelace_format) }} &#8371;</span>
              </p>
              <v-alert color="secondary" class="my-4" border="bottom" type="info" colored-border>
                Please bookmark <a :href="`#/?order=${order_id}`">this link</a> to return to this page if you need to
                check your order status or pay later.
              </v-alert>
              <v-alert class="my-4" v-if="orderUnpaid()"
                       color="indigo" border="left" type="info">
                If payment is not received, this order will expire in
                <Countdown :timestamp="order_status.expires_at"></Countdown>
              </v-alert>
              <v-alert class="my-4" v-if="transaction_id !== null || order_status.status === 'pending'" color="green"
                       border="left" type="info">
                A payment has been submitted for this order! <span
                  v-if="transaction_id"><br />Transaction ID: {{ transaction_id }}</span>
              </v-alert>

              <div class="my-4" v-if="!orderUnpaid()">
                <v-alert class="my-4" color="accent" border="left" type="success">
                  Your order has been paid! Our team will contact you as your order progresses through the fulfillment
                  pipeline.
                </v-alert>
                <v-btn color="primary" x-large @click="clearOrder">Order Another</v-btn>
              </div>
            </v-col>
          </v-row>

        </div>
        <div v-if="cardano.status === 'found'">
          <v-row justify="center" v-if="order_status === null || ['pending','waiting'].includes(order_status.status)">
            <v-col cols="12" lg="8" xl="6" class="justify-center text-center">
              <h2 class="d-flex justify-center text-center mb-4">Please connect your wallet to begin</h2>
              <v-btn v-for="wallet in cardano.Wallets" :key="wallet.name" :title="wallet.name" :loading="wallet.loading"
                     class="me-2" @click="checkingBalance=true;connect(wallet)">
                <v-img :src="wallet.icon" max-width="24" max-height="24" contain class="me-2" />
                {{ wallet.name }}
              </v-btn>
            </v-col>
          </v-row>
        </div>
        <div v-if="cardano.status === 'notfound'">
          <v-row justify="center">
            <v-col cols="12" lg="8" xl="6">
              <v-alert color="orange" border="left" type="error">
                Sorry, we could not detect a Cardano light wallet (Nami, Eternl, Typhon, Flint, etc) on your browser. A
                Cardano light wallet is required to load your rockets and make your payment. Please connect with a
                different device that does have a Cardano light wallet installed.
              </v-alert>
            </v-col>
          </v-row>
        </div>
        <div v-if="cardano.status === 'connected'" class="my-2">
          <v-row justify="center">
            <v-col cols="12" lg="8" xl="6">
              <h2 class="d-flex justify-space-between align-center">
              <span>
                <span class="d-flex flex-row align-center">
                <v-img :src="cardano.ActiveWallet.icon" max-width="24" max-height="24" contain class="me-2" />
                  {{ cardano.ActiveWallet.name }} connected</span>
              </span>
                <v-btn class="mx-2 mb-2" @click="swapWallet()" :loading="cardano.ActiveWallet.loading"
                       :disabled="checkingBalance || orderBusy">
                  Change Wallet
                </v-btn>
              </h2>
              <p class="body-2">{{ cardano.stake_key }}</p>
              <v-progress-linear height="12" indeterminate v-if="checkingBalance" color="orange"></v-progress-linear>
              <p v-if="!checkingBalance && balance.lovelace !== undefined" class="my-2">
                Wallet Balance:
                <v-chip label color="gray" v-if="balance.lovelace !== undefined" class="me-2">
                  {{ toAda(balance.lovelace).toLocaleString(undefined, {minimumSignificantDigits: 6}) }} Lovelace
                </v-chip>
                <v-chip label color="orange" v-if="balance.rockets !== undefined" class="me-2">
                  {{ balance.rockets.length }} Rockets!
                </v-chip>
              </p>
              <template v-if="!order_status && !checkingBalance">
                <template v-if="balance !== null && balance.rockets !== null && balance.rockets.length">
                  <h2 class="text-center justify-center">Choose Your Rocket to Print</h2>
                  <v-row class="my-2" justify="center">
                    <v-col cols="6" v-for="rocket in pagedRockets()" :key="rocket.assetId">
                      <v-card @click="selectRocket(rocket)" :color="rocket.selected ? 'orange' : ''"
                              :dark="!!rocket.selected" v-if="rocket.metadata !== undefined" :disabled="orderBusy">
                        <v-img :src="rocket.metadata.image" :alt="rocket.metadata.name" />
                        <v-card-title class="text-center justify-center" style="word-break: break-word">
                          {{ rocket.metadata.name }}
                        </v-card-title>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-pagination v-if="balance.rockets !== undefined && balance.rockets.length > rocketsPerPage"
                                v-model="rocketPage" :length="countPages()" :total-visible="5" circle
                                color="orange"></v-pagination>
                </template>
                <template v-if="balance.rockets !== undefined && balance.rockets.length === 0">
                  <v-alert color="red" type="error" border="left">
                    Sorry, we could not find any Adosia 3D Space Rockets in your connected wallet! Please try again with
                    a different wallet!
                  </v-alert>
                </template>
                <template v-if="getSelected()">
                  <v-form ref="form" v-model="orderValid" :disabled="orderBusy">
                    <h2>Order Details</h2>
                    <v-row>
                      <v-col cols="6">
                        <v-text-field readonly label="Rocket to Print" v-model="orderDetails.rocketId" color="orange"
                                      required />
                      </v-col>
                      <v-col cols="6">
                        <v-text-field readonly label="Price" :value="getPrice()" prefix="Estimated:" suffix="₳"
                                      color="orange" />
                      </v-col>
                    </v-row>
                    <h2>Please Provide Your Contact Details</h2>
                    <v-text-field label="Your Name" color="orange" required v-model="orderDetails.name"
                                  :rules="orderRules.name"></v-text-field>
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-text-field label="Email Address" required color="orange" :rules="orderRules.email"
                                      v-model="orderDetails.email"></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field label="Phone Number" color="orange" v-model="orderDetails.phone"></v-text-field>
                      </v-col>
                    </v-row>

                    <h2>Provide Your Shipping Address</h2>
                    <v-text-field label="Street Address" color="orange" required :rules="orderRules.street1"
                                  v-model="orderDetails.street1"></v-text-field>
                    <v-text-field label="Street Address 2" color="orange" v-model="orderDetails.street2"></v-text-field>
                    <v-text-field label="Street Address 3" color="orange" v-model="orderDetails.street3"></v-text-field>
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-text-field label="City" color="orange" required v-model="orderDetails.city"
                                      :rules="orderRules.city"></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field label="State/Province" color="orange" v-model="orderDetails.state"></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row class="mt-0">
                      <v-col cols="12" md="6">
                        <v-text-field label="Country" required color="orange" v-model="orderDetails.country"
                                      :rules="orderRules.country"></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field label="Postal Code" required color="orange" :rules="orderRules.postal"
                                      v-model="orderDetails.postal"></v-text-field>
                      </v-col>
                    </v-row>
                    <p>
                      Your order for a 3D printed rocket is bound by our <a href="http://adosia.com/TOS.html"
                                                                            target="_blank" class="orange--text">Terms
                                                                                                                 of
                                                                                                                 Service</a>
                      and <a href="http://adosia.com/PrivacyPolicy.html" target="_blank" class="orange--text">Privacy
                                                                                                              Policy</a>.
                      Please read them and indicate your agreement below. </p>
                    <v-switch v-model="orderDetails.terms" inset color="orange" :label="tosLabel" required
                              :rules="orderRules.terms" />
                    <v-btn :disabled="!orderValid" color="orange" @click="submitOrder()">
                      Place Order
                    </v-btn>
                  </v-form>
                </template>
              </template>
              <template v-if="order_status">
                <template v-if="!checkingBalance">
                  <template v-if="!canPayInvoice()">
                    <v-alert color="red" type="error" border="left" class="my-4">
                      Sorry, this wallet does not have a sufficient balance to pay for your order. Please connect a
                      different wallet and try again.
                    </v-alert>
                  </template>
                  <template v-if="canPayInvoice() && orderUnpaid()">
                    <v-btn color="orange" x-large @click="payInvoice()" :disabled="orderBusy">Pay Now</v-btn>
                  </template>
                </template>
              </template>
            </v-col>
          </v-row>

        </div>

      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
import Countdown from "@/components/Countdown";

const rocket_policy = 'afeb6eb5b01dcfcf81851fc74821cf52f1ce449818a124fc999934d6';

export default {
  name: 'App',
  components: {Countdown},
  data: () => ({
    checkingBalance: false,
    balance: {},
    rocketPage: 1,
    rocketsPerPage: 2,
    orderDetails: {
      rocketId: null,
      price: null,
      name: null,
      email: null,
      phone: null,
      street1: null,
      street2: null,
      street3: null,
      city: null,
      state: null,
      country: null,
      postal: null,
      terms: null
    },
    orderValid: true,
    orderBusy: false,
    order_id: null,
    order_status: null,
    orderRules: {
      name: [
        v => !!v || 'Your name is required!'
      ],
      email: [
        v => !!v || 'Your email is required!'
      ],
      street1: [
        v => !!v || 'You must provide a street address'
      ],
      city: [
        v => !!v || 'You must provide your city'
      ],
      country: [
        v => !!v || 'You must provide your country'
      ],
      postal: [
        v => !!v || 'You must provide your postal code'
      ],
      terms: [
        v => !!v || 'You must agree to the above listed terms of service and privacy policy to place your order!'
      ]
    },
    lastAdaValue: null,
    adaValue: null,
    transaction_id: null,
    rocketPrice: 79.95,
    tosLabel: `I have read and agree to be bound by the Adosia Terms of Service and Privacy Policy.`,
    lovelace_format: {
      maximumFractionDigits: 6,
      minimumFractionDigits: 6,
    },
    checkingOrderStatus: null,
  }),
  methods: {
    orderUnpaid() {
      if (this.order_status === null) {
        return false;
      }

      const status = this.order_status.status;

      return status === 'pending' || status === 'waiting';
    },
    canPayInvoice() {
      const balance = parseInt(this.balance.lovelace);
      const price = parseInt(this.order_status.price);

      return balance >= price;
    },
    async markPaid() {
      this.orderBusy = true;
      let response = null;
      try {
        response = await axios.post('https://adosia.buffybot.io/api/v1/order/pay/', {
          order_id: this.order_id,
          transaction_id: this.transaction_id
        });
      } catch (e) {
        console.error("Marking Paid Error:", e);
        this.$swal.fire({
          title: 'Error!',
          icon: 'error',
          html: `Sorry, we've encountered an issue attempting to submit your transaction ID to the server.` +
              `Please make a note of your transaction ID and order ID and contact our technical support!`,
          showConfirmButton: true,
          confirmButtonText: 'Okay'
        });
        setTimeout(() => {
          this.markPaid();
        }, 15000);
        this.orderBusy = false;
        return;
      }

      this.order_status = response.data;
      this.order_status.expires_at = new Date(response.data.expires_at);
      this.orderBusy = false;
    },
    async payInvoice() {
      const tx = await this.makeTransaction(this.order_status.recipients);
      let signed;
      try {
        signed = await this.signTransaction(tx);
      } catch (e) {
        console.error("Sign Transaction Error:", e);
        this.$swal.fire({
          title: "Transaction Declined",
          icon: 'error',
          html: `You did not sign the transaction. Your payment has not been submitted.`,
          showConfirmButton: true,
          confirmButtonText: 'Okay'
        });
        return;
      }
      let transaction_id;
      try {
        transaction_id = await this.submitTransaction(signed.tx, [signed.witnesses]);
      } catch (e) {
        console.error("Submission Error:", e);
        return;
      }
      this.transaction_id = transaction_id;

      this.$swal.fire({
        title: "Transaction Submitted!",
        icon: "success",
        html: `Your transaction has been submitted to the blockchain!<br />Transaction ID: ${this.transaction_id}`,
        showConfirmButton: true,
        confirmButtonText: 'Okay'
      });

      await this.markPaid();
    },
    async lookupOrder() {
      this.orderBusy = true;
      let response = null;
      try {
        response = await axios.post('https://adosia.buffybot.io/api/v1/order/lookup/', {
          order_id: this.order_id
        });
      } catch (e) {
        console.error("Order Lookup Error:", e);
        this.$swal.fire({
          title: 'Error Looking Up Order!',
          icon: 'error',
          html: "Sorry, we encountered an error looking up your order. Please try again later!",
          showConfirmButton: true,
          confirmButtonText: 'Okay'
        });
        this.orderBusy = false;
        return;
      }

      this.order_status = response.data;

      if (this.order_status.status !== 'paid' && this.checkingOrderStatus === null) {
        this.checkingOrderStatus = setInterval(() => {
          this.lookupOrder();
        }, 30000);
      }
      if (this.order_status.status === 'paid' && this.checkingOrderStatus !== null) {
        clearInterval(this.checkingOrderStatus);
      }
      this.order_status.expires_at = new Date(response.data.expires_at);
      this.orderBusy = false;
    },
    async submitOrder() {
      this.orderBusy = true;
      let response = null;
      try {
        response = await axios.post('https://adosia.buffybot.io/api/v1/order/submit/', this.orderDetails);
      } catch (e) {
        console.error("Order Submit Error:", e);
        this.$swal.fire({
          title: "Error submitting order!",
          icon: "error",
          html: "We encountered an error submitting your transaction. Please try again later!",
          showConfirmButton: true,
          confirmButtonText: 'Okay'
        });
        this.orderBusy = false;
        return;
      }
      if (response.data.order_id) {
        this.$swal.fire({
          title: 'Order Submitted',
          icon: 'success',
          html: "Your order has been submitted. Order ID: " + response.data.order_id,
          showConfirmButton: true,
          confirmButtonText: 'Okay'
        });
        this.$route.query.order = response.data.order_id;
        this.order_id = response.data.order_id;
        await this.lookupOrder();
      }
      this.orderBusy = false;
    },
    async getAdaPrice() {
      const adausd = await axios.get('https://adosia.buffybot.io/api/v1/price/adausd/');
      if (adausd.data.price) {
        if (this.adaValue !== null) {
          this.lastAdaValue = this.adaValue;
        }
        this.adaValue = adausd.data.price;
      }
    },
    getPrice() {
      return (this.rocketPrice / this.adaValue).toFixed(6);
    },
    toAda(lovelace) {
      return lovelace / 1000000;
    },
    toLovelace(Ada) {
      return Ada * 1000000;
    },
    swapWallet() {
      this.balance = {};
      this.changeWallet();
    },
    async checkForBalances() {
      this.checkingBalance = true;
      this.balance.lovelace = await this.checkBalance();
      this.balance.rockets = await this.getTokens(rocket_policy);
      if (this.balance.rockets !== undefined && this.balance.rockets.length > 0) {
        for (let i = 0; i < this.balance.rockets.length; i++) {
          const rocket = this.balance.rockets[i];
          const metadata = await this.getTokenData(rocket.policy_id, rocket.asset_id);
          this.balance.rockets[i].selected = false;
          this.balance.rockets[i].metadata = metadata;
        }
      }
      this.checkingBalance = false;
    },
    async getTokenData(policy_id, asset_id) {
      const rocket_name = this.toAscii(this.fromHex(asset_id));
      const rocket_number = parseInt(rocket_name.replace('SpaceRocket', ''));

      return {
        name: rocket_name.replace('SpaceRocket', 'Space Rocket #'),
        image: `https://adosia.buffybot.io/rockets/${rocket_number}.png`
      };

      // const response = await axios.get(`https://api.koios.rest/api/v0/asset_info?_asset_policy=${policy_id}&_asset_name=${asset_id}`);
      // return response.data[0].minting_tx_metadata;
    },
    selectRocket(rocket) {
      this.balance.rockets.forEach((other_rocket) => {
        if (other_rocket.name !== rocket.name) {
          other_rocket.selected = false;
        }
      });

      this.orderDetails.rocketId = rocket.name;
      rocket.selected = true;
      this.$forceUpdate();
    },
    getSelected() {
      let selected = false;
      if (this.balance.rockets === undefined || this.balance.rockets.length === 0) {
        return false;
      }
      this.balance.rockets.forEach((rocket) => {
        if (rocket.selected) {
          selected = rocket;
        }
      });


      return selected;
    },
    pagedRockets() {
      // const page = 0;
      if (!this.balance.rockets || this.balance.rockets.length === 0) {
        return [];
      }
      let offset = (this.rocketPage - 1) * this.rocketsPerPage;
      const returnTo = Math.min((offset + this.rocketsPerPage), this.balance.rockets.length);
      const range = [];
      for (offset; offset < returnTo; offset++) {
        range.push(this.balance.rockets[offset]);
      }
      return range;
    },
    countPages() {
      return Math.ceil(this.balance.rockets.length / this.rocketsPerPage);
    },
    hexOnly(str) {
      return str.replace(/[^a-f0-9]/g, '');
    },
    isOrderId(str) {
      const sanitized = this.hexOnly(str);
      if (sanitized.length === 32) {
        return sanitized;
      } else {
        return false;
      }
    },
    clearOrder() {
      this.order_id = null;
      this.order_status = null;
    }
  },
  watch: {
    $route: {
      handler: async function (newRouteValue) {
        const order_id = this.isOrderId(newRouteValue.query.order);
        if (order_id) {
          this.order_id = order_id;
          await this.lookupOrder();
        } else {
          this.$swal.fire({
            title: 'Invalid Order',
            icon: 'error',
            html: `Sorry, that Order ID is invalid`,
            showConfirmButton: true,
            confirmButtonText: 'Okay'
          });
        }
      }
    }
  },
  async mounted() {
    let order_id = this.$route.query.order;

    if (order_id) {
      order_id = this.isOrderId(order_id);
      if (order_id) {
        this.order_id = order_id;
        await this.lookupOrder();
      }
    }

    this.checkForCardano();
    this.$on('connected', this.checkForBalances);
    this.getAdaPrice();
    setInterval(() => {
      this.getAdaPrice();
    }, 60000);
  },
};
</script>

<style>
.swal2-container {
  font-family: 'Roboto', sans-serif;
}

.grecaptcha-badge {
  z-index: 999;
}
</style>